export const beneficiaryDetailTranslations = {
    en: {
        // Tab Labels
        campsVisited: "Camps Visited",
        healthCampActivities: "Health Camp Activities",
        documents: "Documents",
        comments: "Comments",
        followUp: "Follow Up"
    },
    mr: {
        // Tab Labels
        campsVisited: "भेट दिलेली शिबिरे",
        healthCampActivities: "आरोग्य शिबिर क्रियाकलाप",
        documents: "दस्तऐवज",
        comments: "टिप्पण्या",
        followUp: "फॉलो अप"
    }
};
